import clsx from 'clsx';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TemplatesGalleryLoader = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.group,
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(styles.groupTitle, styles.itemLoader),
      style: {
        width: 100
      }
    }), /*#__PURE__*/_jsx("div", {
      className: styles.templates,
      children: Array.from({
        length: 6
      }).map((_, index) => {
        return /*#__PURE__*/_jsx("div", {
          className: clsx(styles.template, styles.itemLoader),
          style: {
            height: 80
          }
        }, `template-${index}`);
      })
    })]
  });
};

export default TemplatesGalleryLoader;